import { selfCheckInRoute } from 'src/apis';

export const completeSelfCheckIn = (rentalId: string): string =>
    `${selfCheckInRoute}/${rentalId}/complete`;
